import Axios, { InternalAxiosRequestConfig } from 'axios'

// import { useNotifications } from '@/components/ui/notifications';
// import { env } from '@/config/env';

export const api = Axios.create({
	baseURL: `${import.meta.env.VITE_API_URL}/api`,
})

api.interceptors.response.use(
	(response) => {
		return response.data
	},
	(error) => {
		const message = error.response?.data?.message || error.message
		// useNotifications.getState().addNotification({
		// 	type: 'error',
		// 	title: 'Error',
		// 	message,
		// })

		// if (error.response?.status === 401) {
		// 	const searchParams = new URLSearchParams()
		// 	const redirectTo =
		// 		searchParams.get('redirectTo') || window.location.pathname
		// 	window.location.href = paths.auth.login.getHref(redirectTo)
		// }

		return Promise.reject(error)
	}
)
